import * as selectors from './selectors'

export const ftLockupsSelectors = selectors
